import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Ensure react-bootstrap is installed
import EvaluationListTranslation from './EvaluationListTranslation';

const EvaluationModal = ({ 
    show, 
    onClose, 
    langCode,
    ...data 
  }) => {
    return (
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Application Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <tbody>
              <tr>
                <th>{EvaluationListTranslation("documentNumber", langCode)['label']}</th>
                <td>{data.documentNumber}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("studySemester", langCode)['label']}</th>
                <td>{data.studySemester}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("country", langCode)['label']}</th>
                <td>{data.country}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("agreementOfficer", langCode)['label']}</th>
                <td>{data.agreementOfficer?.familyName} {data.agreementOfficer?.givenName}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("department", langCode)['label']}</th>
                <td>{data.department}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("language", langCode)['label']}</th>
                <td>
                  {data.language} - {data.languageDescription}
                </td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("languageLevel", langCode)['label']}</th>
                <td>{data.languageLevel}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("averageGrade", langCode)['label']}</th>
                <td>{data.averageGrade}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("studyYearWeight", langCode)['label']}</th>
                <td>{data.studyYearWeight}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("incentive", langCode)['label']}</th>
                <td>{data.incentive}</td>
              </tr>
              <tr>
              <th>{EvaluationListTranslation("comments", langCode)['label']}</th>
                <td>{data.comments}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>

      </Modal>
  );
};

export default EvaluationModal;
